// extracted by mini-css-extract-plugin
module.exports = {"desktop":"UserColor_desktop__3_DSn","mobile":"UserColor_mobile__3P2B-"};